import { render } from "./ResidentDocument.vue?vue&type=template&id=619ce586"
import script from "./ResidentDocument.vue?vue&type=script&lang=js"
export * from "./ResidentDocument.vue?vue&type=script&lang=js"

import "./ResidentDocument.vue?vue&type=style&index=0&id=619ce586&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__